import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js';
import Routes from './routes/Routes';
import * as serviceWorker from './serviceWorker';

import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { ConnectedRouter } from 'connected-react-router'
import { store, persistor, history } from './configureStore/store';

import "./index.sass";
import "./index.css"
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import colors from '@bit/wavfichacerta.fichacerta.styles-utils.colors';
import mediaTemplates from '@bit/wavfichacerta.fichacerta.styles-utils.media-templates';
import ReduxToastr from 'react-redux-toastr'
import AnalyticsService from './services/analytics/AnalyticsService';

const theme = {
  ...colors,
  ...mediaTemplates,
  disabled: false,
  dynamicPhoneButtonColor: "color_white"
}

if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    defaults: '2026-01-30',
    opt_out_capturing_by_default: process.env.NODE_ENV === 'development',
  });
  AnalyticsService.init();
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
      <ConnectedRouter history={history}> 
        <Routes />
      </ConnectedRouter>
      </ThemeProvider>
      <ReduxToastr
        timeOut={4000}
        newestOnTop={false}
        preventDuplicates
        progressBar
        closeOnToastrClick
      />
    </PersistGate>
  </Provider>,
document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
